import { useState, useEffect, useRef, Fragment } from 'react'
import { Link } from 'react-router-dom';
import { useTranslation } from "react-i18next";

// import Backdrop from '../../Backdrop/Backdrop';
// import Loader from '../../Loader/Loader';
// import Modal from '../../Modal/Modal';
// import UploadedFileUseContent from '../../UploadedFileUseContent/UploadedFileUseContent';
import VoiceGenerator2Socket from '../VoiceGenerator2Socket';
import VoiceGenerator2NoEnOutput from './VoiceGenerator2NoEnOutput';
import VoiceGeneratorModelSelect from './VoiceGeneratorModelSelect';
import VoiceGeneratorTextInput from './VoiceGeneratorTextInput';
import VoiceGeneratorAction from './VoiceGeneratorAction';

import { useStore } from '../../../hook-store/store';
import { 
  generateTextAudio, 
  getTextToSpeechModels,
  getTextToSpeechApi,
} from '../../../utils/voice-generator2-utils/voice-generator2-utils'

import { TEXTAUDIOTOOLSNODE_URL } from '../../../App';

import { marks } from '../../../utils/marks';
import '../VoiceGenerator2.css';
// import { GeneratedIdentifierFlags } from 'typescript';

// const modelList = [
//   {language: 'en', repoId: 'csukuangfj/vits-piper-en_US-glados|1 speaker'},
//   {language: 'tha', repoId: 'csukuangfj/vits-mms-tha'},
//   {language: 'nan', repoId: 'csukuangfj/vits-mms-nan'},
// ];
  // Thai "csukuangfj/vits-mms-tha", ฉันรักคุณ
  // Min-nan (闽南话) "csukuangfj/vits-mms-nan",  ài piaǸ chiah ē iaN̂
  

function VoiceGenerator2NoEn() {

  const [t] = useTranslation("translation");

  const hiddenFileSelect = useRef(null);

  const [store, dispatch] = useStore();
  const { 
    textToSpeechApiExist,
    isVoiceGenerating,
  } = store.mlVoiceStore;
  const { 
    usageBasedPrice,
    usageBasedSubscription,
  } = store.stripeData;
  const { paramFileData } = store.uiStore;

  // console.log('ttsGenModels', ttsGenModels);

  const [isModelLoading, setIsModelLoading] = useState(true);
  const [generatedAudioFiles, setGeneratedAudioFiles] = useState([]);
  const [textInput, setTextInput] = useState('');
  const [ttsGenLng, setTtsGenLng] = useState('');
  const [ttsGenRepoId, setTtsGenRepoId] = useState("");
  const [speakerId, setSpeakerId] = useState('0');
  const [genSpeed, setGenSpeed] = useState(1);
  const [ttsGenModels, setTtsGenModels] = useState([]);
  const [ttsGenMaxText, setTtsGenMaxText] = useState(0);
  const [ttsGenFreeMaxText, setTtsGenFreeMaxText] = useState(0);
  const [textToSpeechConfig, setTextToSpeechConfig] = useState();
  const [showModalUseUploadedFile, setShowModalUseUploaded] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    getTtsModelsHandler();
  },[]);


  useEffect(() => {

    getTtsApiHandler();

    const getApiInterval = setInterval(() => {
        getTtsApiHandler();
      }, 1000*10);

    return () => {
      clearInterval(getApiInterval);
    }

  },[]);


  useEffect(() => {
    if (paramFileData && paramFileData.openApp === 'voiceGeneratorNoen' 
          && !isModelLoading
    ) {
      setParamFileHandler();
    }

  }, [paramFileData, isModelLoading]);


  // const handleInputClick = (event) => {
  //   hiddenFileSelect.current.click()
  // };

  // const textInputHandler = (event) => {
  //   setTextInput(event.target.value);
  //   // const textArea = document.getElementById('tts-text');
  //   // textArea.value = event.target.value;
  // }

  // Thai "csukuangfj/vits-mms-tha", ฉันรักคุณ
  // Min-nan (闽南话) "csukuangfj/vits-mms-nan",  ài piaǸ chiah ē iaN̂
  

  const setParamFileHandler = async () => {
    try {
      const files = [paramFileData.file];

      const fileUrl = URL.createObjectURL(files[0]);
      // const mimeType = files[0].type;

      const response = await fetch(fileUrl);

      const resData = await response.text();

      if (resData) {
        setTextInput(resData);
  
        dispatch('SET_PARAMFILEDATA', null);
      }


    } catch(err) {
      console.log(err);
    }
  };


  // const generateAudioHandler = async () => {
  //   // const generateBtn = document.getElementById('tts-generateBtn');
  //   // generateBtn.click();
  //   try {

  //     setIsLoading(true);
  //     dispatch('CLEAR_NOTIFICATION');

  //     let sId = speakerId;

  //     if (!speakerId) {
  //       sId = '0';
  //     }

  //     // throw new Error('error-error')

  //     const audioFileData = await generateTextAudio(
  //       TEXTAUDIOTOOLSNODE_URL,
  //       localStorage.getItem('token'),
  //       ttsGenLng,
  //       ttsGenRepoId,
  //       textInput,
  //       sId,
  //       genSpeed,
  //       localStorage.getItem('customerId'),
  //       usageBasedPrice.id,
  //     );

  //     if (audioFileData) {
  //       const modelDisplayName = createModelDisplayName(
  //         ttsGenModels, 
  //         ttsGenLng,
  //         ttsGenRepoId,
  //       );
        
  //       const addedList = [
  //         {
  //           ...audioFileData,
  //           modelDisplayName: modelDisplayName,
  //         }
  //       ].concat(generatedAudioFiles)
  //       setGeneratedAudioFiles(addedList.slice(0,3));

  //       dispatch('SHOW_NOTIFICATION', {
  //         status: '',
  //         title: 'audio generated',
  //         message: '',
  //       });
  
  //       setTimeout(() => {
  //         dispatch('CLEAR_NOTIFICATION');
  //       },1000 * 5);
  //     }

  //     setIsLoading(false);

  //   } catch(err) {
  //     setIsLoading(false);
  //     console.log(err);

  //     dispatch('SHOW_NOTIFICATION', {
  //       status: 'error',
  //       title: 'audio generation failed',
  //       message: '',
  //     });
  //     // throw err;
  //   }
  // };

  const getTtsModelsHandler = async () => {
    try {

      setIsModelLoading(true);

      const resData = await getTextToSpeechModels(
        TEXTAUDIOTOOLSNODE_URL,
        localStorage.getItem('token'),
      );

      const ttsModelList = [];

      if (resData.data) {
        for (const data in resData.data) {
          // console.log(model);
          ttsModelList.push({
            code: data,
            name: resData.data[data].name,
            models: resData.data[data].models,
          })
        }

        console.log(ttsModelList);
        setTtsGenModels(ttsModelList);

        setTtsGenLng(ttsModelList[0].code);
        // setTtsGenRepoId(ttsModelList[0].models[0])
        setTtsGenMaxText(resData.ttsMaxTextLength);
        setTtsGenFreeMaxText(resData.ttsFreeMaxTextLength);
        setTextToSpeechConfig(resData.textToSpeechConfig);

      }

      setIsModelLoading(false);

    } catch(err) {
      setIsModelLoading(false);
      console.log(err);
      // throw err;
    }

  }

  const getTtsApiHandler = async () => {
    try {
      const resData = await getTextToSpeechApi(
        TEXTAUDIOTOOLSNODE_URL,
        localStorage.getItem('token'),
      );

      if (resData) {
        console.log(resData);
        dispatch('SET_TEXTTOSPEECHAPIEXIST', true);
      }

    } catch(err) {
      console.log(err);
      dispatch('SET_TEXTTOSPEECHAPIEXIST', false);
      // throw err;
    }

  }


  const createModelDisplayName = (ttsGenModels, ttsGenLng, ttsGenRepoId) => {
    let modelDisplayName = '';

    if (ttsGenModels && ttsGenModels.length > 0 && ttsGenLng) {
      const selectedModelData = ttsGenModels.find(model => {
        return model.code === ttsGenLng;
      })
  
      if (selectedModelData) {
      
        if (ttsGenRepoId) {
          const repoIndex = selectedModelData.models.indexOf(ttsGenRepoId);
          const modelDesc = ttsGenRepoId.split('/')[1].split('|')[0];

          modelDisplayName = `${selectedModelData.name} - ${repoIndex + 1} (${modelDesc})`;
        }
      }
    }

    return modelDisplayName;

  };


  // let selectedLngModels = [];
  // let genButtonDisabled = false;
  // let genButtonText = `${t('voiceGenerator07', 'Generate audio')}`;
  // let numberOfSpeakerId = 1;

  // if (ttsGenModels && ttsGenModels.length > 0 && ttsGenLng) {
  //   const selectedModelData = ttsGenModels.find(model => {
  //     return model.code === ttsGenLng;
  //   })

  //   if (selectedModelData) {
  //     selectedLngModels = [''].concat(selectedModelData.models);
  //   }

  // }

  // if (isModelLoading || isLoading || !ttsGenLng || !ttsGenRepoId || !textInput) {
  //   genButtonDisabled = true;
  // }

  // if (!textToSpeechApiExist) {
  //   genButtonDisabled = true;
  //   genButtonText = `${t('voiceGenerator08', 'Busy...')}`
  // }

  // if (textInput && textInput.length > ttsGenMaxText) {
  //   genButtonDisabled = true;
  // }


  // let isUsageBased = false;
  // let isUsageBasedOk = true;

  // if (textInput.length > ttsGenFreeMaxText) {
  //   isUsageBased = true;
  // }

  // if (ttsGenRepoId && getSpeakerNumFromRepoId(ttsGenRepoId) > 1) {
  //   numberOfSpeakerId = getSpeakerNumFromRepoId(ttsGenRepoId);
  // }

  let bannerElement;

  if (window.innerWidth <= 450) {
    bannerElement = (
      <iframe id="kura-text-audio-tools.spaceeight.net-1725583665876"
          style={{width:"310px", height:"70px", border:"none"}}  
          src="https://adnetwork-adserviceadpage.spaceeight.net?adPlaceId=kura-text-audio-tools.spaceeight.net-1725583665876"
      />
    );
  }

  if (window.innerWidth > 450 && window.innerWidth <= 768) {
    bannerElement = (
      <iframe id="kura-text-audio-tools.spaceeight.net-1725583679744"
      style={{width:"460px", height:"95px", border:"none"}}  
      src="https://adnetwork-adserviceadpage.spaceeight.net?adPlaceId=kura-text-audio-tools.spaceeight.net-1725583679744"
      />
    )
  }

  if (window.innerWidth > 768) {
    bannerElement = (
      <iframe id="kura-text-audio-tools.spaceeight.net-1725583699146"
          style={{width:"610px", height:"135px", border:"none"}}  
          src="https://adnetwork-adserviceadpage.spaceeight.net?adPlaceId=kura-text-audio-tools.spaceeight.net-1725583699146"
      />
    );
  }


  let voiceGeneratorBody;

  if (ttsGenModels && ttsGenModels.length > 0) {
    voiceGeneratorBody = (
      <div className='voiceGenerator2'>
        <div 
          style={{
                  display: 'flex',
                  justifyContent: "center",
                  paddingTop: "1rem",
                  paddingBottom: "2rem"
              }}
          >
            {bannerElement}
        </div>

        {/* {JSON.stringify(textToSpeechConfig)} */}

        <div className='voiceGenerator2Section'>
          <div className='voiceGenerator2Title'>
            Voice Generator
          </div>
          {/* <div className='voiceGenerator2TitleSub'>
            (<Link to="/voice-generator">
              {t('voiceGenerator01', 'go to Voice Generator for English page')}
            </Link>)
          </div> */}
        </div>

        <div className='voiceGenerator2Section'>
          <VoiceGeneratorModelSelect 
            ttsGenModels={ttsGenModels}
            speakerId={speakerId}
            setSpeakerId={setSpeakerId}
            genSpeed={genSpeed}
            setGenSpeed={setGenSpeed}
            ttsGenRepoId={ttsGenRepoId}
            setTtsGenRepoId={setTtsGenRepoId}
            ttsGenLng={ttsGenLng}
            setTtsGenLng={setTtsGenLng}
            isModelLoading={isModelLoading}
            textInput={textInput}
            ttsGenMaxText={ttsGenMaxText}
            isLoading={isLoading}
          />
        </div>

        <div>
          <VoiceGeneratorTextInput 
            showModalUseUploadedFile={showModalUseUploadedFile}
            setShowModalUseUploaded={setShowModalUseUploaded}
            textInput={textInput}
            setTextInput={setTextInput}
            ttsGenMaxText={ttsGenMaxText}
            ttsGenFreeMaxText={ttsGenFreeMaxText}
            textToSpeechConfig={textToSpeechConfig}
            isLoading={isLoading}
            setIsLoading={setIsLoading}
          />
        </div>

        <div>
          <VoiceGeneratorAction 
            speakerId={speakerId}
            ttsGenLng={ttsGenLng}
            ttsGenModels={ttsGenModels}
            ttsGenRepoId={ttsGenRepoId}
            textInput={textInput}
            genSpeed={genSpeed}
            generatedAudioFiles={generatedAudioFiles}
            setGeneratedAudioFiles={setGeneratedAudioFiles}
            isModelLoading={isModelLoading}
            ttsGenMaxText={ttsGenMaxText}
            ttsGenFreeMaxText={ttsGenFreeMaxText}
            textToSpeechConfig={textToSpeechConfig}
            isLoading={isLoading}
            setIsLoading={setIsLoading}
          />
        </div>
        
        {/* {isGenerating && (
          <Loader />
        )} */}

        {/* <span id='tts-audio-output'></span> */}
        <section></section>
        
        {generatedAudioFiles && generatedAudioFiles.length > 0 && (
          <div className='voiceGenerator2Section'>
            <VoiceGenerator2NoEnOutput 
              generatedAudioFiles={generatedAudioFiles}
              textInput={textInput}
            />
          </div>
        )}
      </div>

    );
  }

  return (
    <Fragment>
      {/* {!textToSpeechApiExist && (
        <div>not-api-exist</div>
      )} */}
      <div>
        {voiceGeneratorBody}
      </div>
      <VoiceGenerator2Socket />
    </Fragment>
  )
}

export default VoiceGenerator2NoEn;
